import AccountFilesRedirect from './AccountFilesRedirect';

export default AccountFilesRedirect;
